module.exports = __webpack_public_path__ + "static/img/login_bg_2.f10ce59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_bg_2.png
// module id = utm1
// module chunks = 1